<template>
<div id="container">
  <div id="monitor">
    <div id="monitorscreen">
      
      <RTStreamLinks :expiredText="!isMobile" :titleText="!isMobile" :stream="stream" class="streamLink"/>
      <div class="monitorContent" :style="monitorStyling"></div>
    </div>
  </div>
</div>
</template>

<script>
import {helper} from '@/mixins/helper.js'
import RTStreamLinks from '@/components/RTStreamLinks.vue'
export default {
  name: 'RTStreamTv',
  components:{
    RTStreamLinks
  },
  mixins:[helper],
  props:{
   stream:{
     type:Object
   },
  },
  data: function() {
    return {

    };
  },
  computed:{
    monitorStyling(){
      let cover = (this.stream)?this.stream.cover:null;
      return {
        'background': `url('${cover}') center center`,
        'background-size': 'cover'
      }
    }
  },
  methods:{
    getMaxWidthOfPlayer(){
      return this.isSmallTouchDevice()?300:640;
    },
    getHeightOfPlayer(){
      return this.isSmallTouchDevice()?200:360;
    }
  }
};
</script>

<style type='text/css' scoped>
.streamLink{
  z-index:1;
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  padding:1em;
  width:100%;
  margin-top: 1em;
}
#container {
  max-width: 1024px;
  margin: auto;
}

#monitor {
  background: #000; 
  position: relative;
  border-top: 3px solid #888; 
  margin: 5%;
  padding: 2% 2% 4% 2%; 
  border-radius: 10px; 
  border-bottom-left-radius: 50% 2%; 
  border-bottom-right-radius: 50% 2%; 
  transition: margin-right 1s;
}

#monitor:after {
  content: '';
  display: block;
  position: absolute;
  bottom: 3%;
  left: 36%;
  height: .5%; 
  width: 28%;
  background: #ddd; 
  border-radius: 50%; 
  box-shadow: 0 0 3px 0 white; 
}

#monitorscreen {
  position: relative;
  background-color: #dcdcdc;
  background-size: cover; 
  background-position: top center;
  height: 0; 
  padding-bottom: 56.25%; 
  position: relative;
  overflow: hidden;
}

.monitorContent {
  content: "";
  position: absolute;
  top: 0; 
  left: 0;
  width: 100%; 
  height: 100%;  
  opacity: .2;
  background-position: center center;
  background-size: cover;
}


@media all and (min-width: 960px) {
  #monitor {
    -webkit-animation: tvflicker .2s infinite alternate; 
    -moz-animation:    tvflicker .5s infinite alternate; 
    -o-animation:      tvflicker .5s infinite alternate; 
    animation:         tvflicker .5s infinite alternate; 
  }

  @-webkit-keyframes tvflicker {
    0%   { box-shadow: 0 0 80px 0 rgba(0,5,0,0.4); }
    100% { box-shadow: 0 0 60px 0 rgba(0,0,0,0.6); }
  }
  @-moz-keyframes tvflicker {
    0%   { box-shadow: 0 0 80px 0 rgba(0,5,0,0.4); }
    100% { box-shadow: 0 0 60px 0 rgba(0,0,0,0.6); }
  }
  @-o-keyframes tvflicker {
    0%   { box-shadow: 0 0 80px 0 rgba(0,5,0,0.4); }
    100% { box-shadow: 0 0 60px 0 rgba(0,0,0,0.6); }
  }
  @keyframes tvflicker {
    0%   { box-shadow: 0 0 80px 0 rgba(0,5,0,0.4); }
    100% { box-shadow: 0 0 60px 0 rgba(0,0,0,0.6); }
  }
}
</style>